module.exports = "/_next/static/images/9b6f79120fdb381a57ae729b55d2a453-email-icon.svg";